var $c047c8fb717ae00a$exports = {};
$c047c8fb717ae00a$exports = {
    "clear": `Rensa`,
    "invalid": `(ogiltigt)`,
    "loading": `L\xe4ser in...`,
    "noResults": `Inga resultat`,
    "valid": `(giltig)`
};


export {$c047c8fb717ae00a$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
